/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import { Attribute, AttributeType, DataType } from "api/story-attributes";
import { LoaderState, INITIAL_LOADER_STATE } from "behaviors/loader/state";
import { Features } from "api/route-data/route-data";

export interface PartialAppState {
  attributes: State;
  features: Features;
}

export enum AttributePageInspectorType {
  Create = "create",
  Edit = "edit"
}

export interface State {
  attributes: Attribute[];
  features: Features;
  app: {
    currentAttribute: Attribute | null;
    error: Error | null;
  };
  ui: {
    inspector: AttributePageInspectorType | null;
    main: LoaderState;
    save: LoaderState;
    attributes: { [name: string]: LoaderState | undefined };
    entityTypes: string[];
    entityTypesError: Error | null;
  };
}

export const NEW_ATTRIBUTE: Attribute = {
  type: AttributeType.Story,
  name: "",
  values: [],
  "display-name": "",
  "data-type": DataType.MultiValuedStrings,
  "is-mandatory": false
};

export const INITIAL_ATTRIBUTES_STATE: State = {
  attributes: [],
  features: {},
  app: {
    currentAttribute: null,
    error: null
  },
  ui: {
    inspector: null,
    main: INITIAL_LOADER_STATE,
    save: INITIAL_LOADER_STATE,
    attributes: {},
    entityTypes: [],
    entityTypesError: null
  }
};
